import { createSelector } from '@reduxjs/toolkit';

import { AppState } from './helper';

export const selectUser = (state: AppState) => state.user;

export const createSortedHabitatsSelector = (preferLiveTalk: boolean) =>
  createSelector(
    (state: AppState) => state.allHabitats,
    (state: AppState) => state.user.subscription,
    (allHabitats, subscription) => {
      return [...allHabitats].sort((a, b) => {
        // sort by liveTalk status
        if (preferLiveTalk && a.liveTalk !== b.liveTalk) {
          return b.liveTalk ? 1 : -1;
        }
        // if user is not subscriber, prioritize freeHabitats
        if (!subscription.active) {
          const aIsFree = subscription.freeHabitats?.includes(a._id);
          const bIsFree = subscription.freeHabitats?.includes(b._id);
          if (aIsFree !== bIsFree) {
            return aIsFree ? -1 : 1;
          }
        }
        // sort by online status
        if (a.isStreamOn !== b.isStreamOn) {
          return b.isStreamOn ? 1 : -1;
        }
        // sort by index ( considering index:0 as undefined )
        if ((a.index || Number.MAX_SAFE_INTEGER) !== (b.index || Number.MAX_SAFE_INTEGER)) {
          return (a.index || Number.MAX_SAFE_INTEGER) - (b.index || Number.MAX_SAFE_INTEGER);
        }
        // sort by currentViewers or alphabetically
        return b.currentViewers - a.currentViewers || a.title.localeCompare(b.title);
      });
    },
  );
